import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import Print from "./details/Print";
import { useAssetsEntryModel } from "../assetsEntryModel";

export function ManageAssetsEntry() {
    const { selectedRowKeys } = useAssetsEntryModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print id={selectedRowKeys[0]} />
        </>
    );
}